/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(formData) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      SubmitBoardAnnualMeetingRequirements: {
        $xmlns: 'http://dobs.pa.gov/dp/director/bpm/1.0',
        BoardAnnualMeetingRequireID: formData.boardAnnualMeetingRequireId,
        EntityID: formData.entityId,
        AnnualMeetingDue: formData.annualMeetingDue,
        BoardTypeID: formData.boardTypeId,
        Terms: formData.terms,
        BoardSizeMin: formData.boardSizeMin,
        BoardSizeMax: formData.boardSizeMax,
        Comments: formData.comments,
        IsDeleted: formData.isDeleted
      }
    },
    blueprint: {
      boardAnnualMeetingRequireId: '$..BoardAnnualMeetingID'
    }
  })
    .done(function(response) {
      cleanUpResponse(response, { cleanUpTextKeys: true });
      deferred.resolve(response.boardAnnualMeetingRequireId);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
